import angular from 'angular';

/**
 * @ngdoc overview
 * @name superuserModule.superuserServices
 * @description
 * # superuserModule.superuserServices
 * Module for managing the common services.
 */
const superuserServices = angular.module('superuserModule.superuserServices', []);

/**
 * @ngdoc interface
 * @name superuserModule.superuserServices.interface:AdminTable
 * @description
 * Service for handling common features of admin tables
 */
superuserServices.service('AdminTable', [function () {
    'use strict';

    const accessClass = 'fa fa-check-circle-o text-success';
    const forbiddenClass = 'fa fa-circle-o text-muted';

    this.getReadClass = (module) => {
        return (module === 1 || module === 3) ? accessClass : forbiddenClass;
    };

    this.getWriteClass = (module) => {
        return (module >= 2) ? accessClass : forbiddenClass;
    };
}]);

/**
 * @ngdoc interface
 * @name superuserModule.superuserServices.interface:SystemModules
 * @description
 * Service for handling common features for System Modules
 */
superuserServices.service('SystemModules', [function () {
    'use strict';

    const modules = 'user,application,section,cms_www,users,messages,products,reviews,orders,shops,exhibitors,news,games,dishes,notes,levels,meetings,ads,gamifications,provider,chats,maps,posts,competitions,groups,files,sso,libraries,galleries,forms,polls,recipes,promotions,newspapers,evaluations,banners,level_rebuses,rebuses,logs,price_lists,coupons,integrations,users_www,data_management_users,categories,shopping_lists,facets,short_codes,themes'.split(',');
    //    const modules = 'user,application,section,menu'.split(',');
    const states = 'admin.users,admin.apps,application.sections,application.cms_www,application.menu,application.users,application.messagess,application.products,application.reviews,application.orders,application.shops,application.exhibitors,application.news,application.games,application.dishes,application.provider,application.notes,application.levels,application.meetings,application.ads,application.gamifications,application.chats,application.maps,application.posts,application.competitions,application.groups,application.files,application.sso,application.libraries,application.galleries,application.forms,application.polls,application.recipes,application.promotions,application.newspapers,application.evaluations,application.banners,application.level_rebuses,application.rebuses,application.logs,application.price_lists,application.coupons,application.integrations,users_www,data_management.users,application.categories,application.shopping_lists,application.facets,application.short_codes,application.themes'.split(',');

    const advancedModules = 'beacon'.split(',');

    const intToReadWrite = (module) => {
        const readModules = [1, 3, 5, 7];
        const writeModules = [2, 3, 6, 7];

        return {
            read: (readModules.indexOf(module) >= 0),
            write: (writeModules.indexOf(module) >= 0),
            advanced: (module > 3)
        };
    };

    this.getModules = () => {
        return modules;
    };

    this.getAdvancedModules = () => {
        return advancedModules;
    };

    this.getReadWriteModules = (clientPackage) => {
        const _modules = {};

        angular.forEach(modules, (module) => {
            _modules[module] = intToReadWrite(clientPackage[module]);
        });

        if (_modules.products.read === false && _modules.products.write === false) {
            _modules.orders.read = false;
            _modules.orders.write = false;
            _modules.reviews.read = false;
            _modules.reviews.write = false;
        }

        return _modules;
    };

    this.getPermissions = (modules) => {
        const permissions = {};

        angular.forEach(modules, (module, key) => {
            let permission = 0;
            if (module.read) {
                permission = 1;
            }
            if (module.write) {
                permission = permission + 2;
            }
            if (module.advanced) {
                permission = permission + 4;
            }
            permissions[key] = permission;
        });

        return permissions;
    };

    this.countPermissions = (modules) => {
        let count = 0;

        angular.forEach(modules, (module) => {
            if (module.read) {
                count += 1;
            }
            if (module.write) {
                count += 1;
            }
            if (module.advanced) {
                count += 1;
            }
        });

        return count;
    };

    this.getDefaultState = (module) => {
        const index = modules.indexOf(module);

        return index >= 0 ? `appsoup.${states[index]}` : 'appsoup.dashboard';
    };
}]);

export default superuserServices;
